import React, { useState, useEffect } from "react";
import { Drawer, Empty, Typography } from "antd";
import "./index.less";
import Logo1 from "@/assets/images/logo.jpg";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useBaseRequest from "@/hooks/useBaseRequest";
import {
  getHelpInfo
} from "@/api/index";


const { Paragraph } = Typography

// interface HelpData {
//   sysname: string,
//   syslogo: string,
//   syssummary: string,
//   helpData: [],
//   onSearch: Function,
//   zntId: any,
//   helpPage: boolean,
//   helpOpen: boolean
// }

function HelpDescription(_props) {
  const {
    syslogo,
    sysname,
    syssummary,
    helpData,
    onSearch,
    zntId,
    helpPage,
    helpOpen
  } = _props
  console.log(zntId, "智能体的id")
  const [expandedA, setExpanded] = useState(false);
  const [active, setActive] = useState("")
  const [ejActive, setEjActive] = useState('')
  const [open, setOpen] = useState(false)
  const [dataId, setDataId] = useState("")
  const [dArr, setDArr] = useState(["怎么办理相关手续", "怎么维护银行卡信息", "一卡通怎么充值"])
  const [_helpData, setHelpData] = useState([]);
  const [items, setItems] = useState([])
  const [key, setKey] = useState("")


  const {
    runAsync: requestGetHelpInfo,
    loading: loadingInitData,
    data: initData,
  } = useBaseRequest(() => getHelpInfo(zntId), {
    manual: true,
    onSuccess(res) {
      let arr = [{
        title: "我的知识",
        key: "knowledge",
        content: []
      }, {
        title: "我的技能",
        key: "skill",
        content: []
      }, {
        title: "我的数据",
        key: "database",
        content: []
      }]
      for (let i = 0; i < arr.length; i++) {
        arr[i].content = res?.data?.[arr[i].key] || []

      }

      console.log(arr)
      setHelpData(arr)
    },
  });

  useEffect(() => {
    if (zntId) {
      if (helpPage) {
        requestGetHelpInfo()
        // if (helpOpen) {

        //   requestGetHelpInfo()
        // } else {
        //   alert(123)
        //   requestGetHelpInfo()
        // }
      }
    }

  }, [zntId])

  console.log(_helpData, "帮助栏信息")


  return <>
    <div className="helpDescription">
      {
        open ? <div className="detail">
          <div className="back">
            <div className="arrow">
              <ArrowLeftOutlined onClick={() => {
                setOpen(false)
              }} />
              <span className="drawTitle">{active}</span>
            </div>

          </div>

          <div className="detailContent" key={"content"}>
            {
              (key === "knowledge" || key === "skill") ? <div className="description">
                <Paragraph>{items}</Paragraph>
              </div> : null
            }
            {
              key === "database" ? <>
                <div className="description">
                  <Paragraph
                    ellipsis={{
                      rows: 3, // 最多显示两行
                      tooltip: true,
                    }}
                  >{items?.description}</Paragraph>
                </div>

                <div className="title">字段信息</div>

                <ul className="detailList">
                  {
                    (items?.columns && items?.columns.length > 0) ? items?.columns.map((jtem, jdex) => {
                      return <li key={jdex} className="helpListText" >
                        <div key={jdex} className={`${ejActive === jtem?.cnName ? "active" : ''} helpContent`} onClick={() => {
                          setEjActive(jtem?.cnName)
                          onSearch(jtem?.cnName)
                        }}>
                          <div className="name" key={jtem?.cnName}>
                            <span className="square" style={{
                              opacity: active === jtem.cnName ? 1 : 0.5
                            }} key={jdex}></span>
                            <span className="text" key={jtem}>{jtem?.cnName}</span>
                          </div>
                          {jtem?.description ? <div className="sm" key={jtem?.description}>{jtem?.description}</div> : null}

                        </div>

                      </li>
                    }) : <Empty />
                  }
                </ul>
              </> : null
            }
          </div>
        </div> :
          <>
            <div className="helpTitle">
              <div className="syslogo">
                <img src={syslogo} />
                {/* <img src={Logo1} /> */}
              </div>
              <div className="helpSystem">
                <div className="sysname">{sysname}</div>
                <div className="syssummary"> <Paragraph
                  ellipsis={{
                    rows: 3, // 最多显示两行
                    tooltip: true,
                  }}
                >{syssummary}</Paragraph></div>
              </div>
            </div>
            <div className="helpContent">
              {
                (_helpData && _helpData.length > 0) ? _helpData.map((item, index) => {
                  return <div key={index} className="helpList">
                    {
                      (item.content && item.content.length) ? <>
                        <div className="title">{item.title}</div>
                        <ul className="list">
                          {
                            (item.content && item.content.length > 0) ? item.content.map((jtem, jdex) => {
                              return <li key={jdex} className="helpListText" >
                                <div key={jdex} className={`${(active === jtem.name || active === jtem.cnName) ? "active" : ''} helpListContent`} onClick={() => {
                                  if (item.key === "knowledge" || item.key === "skill") {
                                    setActive(jtem.name)
                                    setItems(jtem.description)
                                    setKey(item.key)
                                  } else if (item.key === "database") {
                                    setActive(jtem.cnName)
                                    setItems(jtem)
                                    setKey(item.key)

                                  }

                                  setOpen(true)
                                }}>
                                  <span className="square" style={{
                                    opacity: (active === jtem.name || active === jtem.cnName) ? 1 : 0.5
                                  }} key={jdex}></span>
                                  {(item.key === "knowledge" || item.key === "skill") ? <span className="text" key={jtem}>{jtem?.name || ""}</span> : null}
                                  {item.key === "database" ? <span className="text" key={jtem}>{jtem.cnName || ""}</span> : null}


                                </div>

                              </li>
                            }) : <Empty />
                          }
                        </ul>
                      </> : null
                    }


                  </div>
                }) : <Empty />
              }

            </div>
          </>
      }



    </div>
  </>
}

export default HelpDescription